export const hoverAnimationCSS = `
.component {
    transition: transform 0.3s ease-in-out;
}

.component:hover {
    transform: scale(1.1);
}
`;


export const framerHover1 = `
import { motion } from 'framer-motion';

 <motion.button
    whileHover={{ scale: 1.2 }}
    whileTap={{ scale: 0.9 }}
    transition={{ type: "spring", stiffness: 400, damping: 17 }}>
    Hover Me
</motion.button>

`

export const installFramer = `
npm install framer-motion
`

export const framerHover2 = `
import { motion } from 'framer-motion';

const [isActive, setIsActive] = React.useState(false)

<button onClick={() => setIsActive(!isActive)} >Click me</button>
<motion.button
    whileHover={{ scale: isActive ? 0.5 : 1.2 }}
    whileTap={{ scale: 0.9 }}
    transition={{ type: "spring", stiffness: 400, damping: 17 }}>
    Hover Me
</motion.button>

<motion.button
    whileHover={{ rotate: isActive ? -50 : 50 }}
    whileTap={{ scale: 0.9, rotate: isActive ? -180 : 180 }}
    transition={{ type: "spring", stiffness: 400, damping: 17 }}>
    Hover Me
</motion.button>
`